<template>
  <main class="mx-auto max-w-screen-2xl">
    <router-view v-if="isInitializationDone" :current-users-data="currentUsersData"  />
  </main>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import router from './router'

export default {
  data(){
    return {
      isInitializationDone : false,
      defaultIcon : "/profile-icons/blank.png",
      currentUsersData : {},
    }
  },
  mounted(){
    this.initApp(),
    router.beforeEach((to, from, next) => {
      if(to.params.inviteId)localStorage.setItem("inviteId", to.params.inviteId);
      const notRestrictedPaths = ['/sign-in','/privacy']
      const isOnRestrictedSite = !notRestrictedPaths.includes(to.path);
      if(!isOnRestrictedSite)return next();
      // if(!this.isInitializationDone)return;
      if (!this.isSignedIn){
        if(to.path !== '/sign-in')next({ path: '/sign-in' })
        else next()
      }else{
        next()
      }
    }),
    router.afterEach((to) => {
      // alert(to.path);
      // console.log(to.query);
      const webTitle = "Talk Chats";
      if(to.name !== 'Home'){
        document.title = webTitle + " | " + to.name;
      }else{
        const roomId = to.params.chatId;
        firebase.database().ref('chatRooms').child(roomId).child('name').get().then((snapshot)=>{
          if(snapshot.exists()){
            document.title = webTitle + " | " + snapshot.val();
          }else{
            document.title = webTitle;
          }
        });
        
      }
    })
  },
  methods : {
    redirectDefaultSelectedChat(){
      this.$router.push({ name : 'Home', params: { chatId: localStorage.getItem("previousOpenedChatId") || '0' , isAsideExpanded : localStorage.getItem("previousIsAsideExpanded") || '1' , isDiscoverExpanded : localStorage.getItem("previousIsDiscoverExpanded") || '1' } });
    },
    initApp(){
      var currentUser = null;
      firebase.auth().onAuthStateChanged((user)=> {
        if (user) {
          // User is signed in.
          this.signUpIfNewUser(user.uid);
          user.getIdToken().then((accessToken)=> {
            currentUser = {
              displayName: user.displayName,
              email: user.email || "",
              emailVerified: user.emailVerified,
              phoneNumber: user.phoneNumber,
              photoURL: user.photoURL || this.defaultIcon,
              uid: user.uid,
              accessToken: accessToken,
              providerData: user.providerData,
            };
            this.currentUsersData = currentUser;

          });
        } else {
          // User is signed out.
          this.currentUsersData = {
            "uid" : null,
            "displayName" : "",
            "photoURL" : "/profile-icons/icon4.png"
          };
        }
        this.isInitializationDone = true;

        
      }, function(error) {
        console.log(error);
      });
      
    },
    signUpIfNewUser(userId){
      const dbRef = firebase.database().ref();
      dbRef.child("registeredUsers").child(userId).get().then((snapshot) => {
        if (!snapshot.exists()) {
          this.$router.push({ path: '/sign-up' });
        }else{
          this.redirectDefaultSelectedChat();
        } 
      }).catch((error) => {
        console.error(error);
      });
    },
    getUserCostumizedInfo(userId){
      const dbRef = firebase.database().ref();
      dbRef.child("users").child(userId).get().then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          this.currentUsersData.displayName = data.nickname;
          this.currentUsersData.photoURL = this.iconRootUrl + data.icon;
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  },
  computed : {
    isSignedIn(){
      if(this.currentUsersData.uid)return true;
      return false;
    }
  },
  
  
}
</script>
